// extracted by mini-css-extract-plugin
module.exports = {"downloadNotification":"DownloadNotification_downloadNotification__3VnWc","container":"DownloadNotification_container__3qEpy","buttons":"DownloadNotification_buttons__36-YT"};